export function getNewsContent(block) {
  const raw = block?.content;
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

function newsSortMeta(block) {
  const content = getNewsContent(block);
  const featuredPriority = Number(content.featuredPriority || 0);
  const candidate =
    content.publicationDate ||
    content.publicatiedatum ||
    content.date ||
    content.createdAt ||
    block.createdAt;

  if (candidate) {
    const timestamp = new Date(candidate).getTime();
    if (!Number.isNaN(timestamp)) {
      return {
        featuredPriority,
        hasDate: true,
        timestamp,
        order: block.order ?? 0,
      };
    }
  }

  return {
    featuredPriority,
    hasDate: false,
    timestamp: 0,
    order: block.order ?? 0,
  };
}

export function compareNewsNewestFirst(a, b) {
  const aMeta = newsSortMeta(a);
  const bMeta = newsSortMeta(b);
  if (aMeta.hasDate && bMeta.hasDate) return bMeta.timestamp - aMeta.timestamp;
  if (aMeta.hasDate && !bMeta.hasDate) return -1;
  if (!aMeta.hasDate && bMeta.hasDate) return 1;
  return bMeta.order - aMeta.order;
}

function compareHomepageNews(a, b) {
  const aMeta = newsSortMeta(a);
  const bMeta = newsSortMeta(b);
  if (aMeta.featuredPriority !== bMeta.featuredPriority) {
    return bMeta.featuredPriority - aMeta.featuredPriority;
  }
  return compareNewsNewestFirst(a, b);
}

export function isOpenDagBlock(block) {
  const content = getNewsContent(block);
  const heading = String(content.heading || "").toLowerCase();
  const body = String(content.body || "").toLowerCase();
  return (
    content.articleRoute === "/nieuws/open-dag-19-juni" ||
    (heading.includes("open dag") && body.includes("19 juni"))
  );
}

export function getHomepageNewsBlocks(blocks, limit = 3) {
  return blocks
    .filter((block) => block.blockType === "news-highlight" && !isOpenDagBlock(block))
    .sort(compareHomepageNews)
    .slice(0, limit);
}
